<template>
  <div class="home-game bg-ui-panel grey100--text d-flex">
    <div class="game-card-layout d-flex">
      <div class="icon-ctn">
        <v-img
          class="hand"
          :src="require('@/assets/img/games/dice/hand.png')"
          width="200" aspect-ratio="1.4"
        />

        <v-img
          class="beancan-boom"
          :src="require('@/assets/img/games/dice/icon.png')"
          width="100" aspect-ratio="1"
        />

        <div class="rust-items">
          <v-img
            v-for="i in 3"
            :key="i"
            class="case-item"
            :class="`item--${i}`"
            :src="require('@/assets/img/scrap.png')" contain
            aspect-ratio="1"
          />
        </div>
      </div>

      <div class="align-self-end pa-4">
        <div class="game-info mb-1">
          <h3 class="text-uppercase grey100--text text-body-1 font-weight-bold">
            Beancan Blast
          </h3>
          <p class="text--secondary text-body-2">
            Dice with a Rusty spin
          </p>
        </div>


        <h5 class="game-stats text-body-2 text--secondary d-flex align-center">
          <scrap :amount="won" class="mr-2 text--secondary" /> won
        </h5>
      </div>
    </div>

    <div v-if="xpBonus > 1" class="xp-bonus px-2 py-2 font-weight-bold lh-1 text-caption green700 green200--text">
      +{{ (xpBonus - 1) * 100 | toLocale }}% XP
    </div>
  </div>
</template>

<script>
export default {
  props: {
    stats: {
      type: Object,
      default: null,
    },
    conga: {
      type: Object,
      default: null,
    },
  },
  computed: {
    won() {
      return this.stats?.won ?? 0
    },
    xpBonus() {
      return this.conga?.games.dice.xpMultiplier ?? 1
    },
  },
}
</script>

<style lang="scss" scoped>
.home-game {
  position: relative;
  height: 180px;
  cursor: pointer;
  transition: transform 0.3s ease;

  .game-card-layout {
    overflow: hidden;

    @include overlay;
  }

  .icon-ctn {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 70%;
    height: 100%;

    .hand {
      position: absolute;
      z-index: 3;
      right: -28px;
      bottom: -6px;
      transition: transform 0.4s ease;
      transform: rotate(6deg);
    }

    .beancan-boom {
      position: absolute;
      z-index: 2;
      top: 20%;
      right: 20px;
      opacity: 0;
      transition: all 0.5s ease;
      transform: scale(0.6);
    }

    .rust-items {
      @include overlay;

      pointer-events: none;

      .case-item {
        position: absolute;
        z-index: 1;
        width: 100%;
        max-width: 60px;
        opacity: 0;
        transition: transform 0.4s ease, opacity 0.4s ease;

        &.item--1 {
          z-index: 3;
          top: 3%;
          right: 60%;
          transition-delay: 0.2s;
          transform: translateY(85%) translateX(120%) scale(0.1);
        }

        &.item--2 {
          top: 45%;
          left: -10%;
          transition-delay: 0.3s;
          transform: translateY(-20%) translateX(120%) scale(0.2);
        }

        &.item--3 {
          top: 60%;
          right: 45%;
          transition-delay: 0.1s;
          transform: translateY(-55%) translateX(70%) scale(0.2);
        }
      }
    }
  }

  .game-info,
  .game-stats {
    position: relative;
    z-index: 2;
    transition: transform 0.6s ease;
  }

  .game-info {
    text-shadow: 0 0 5px black;
  }

  .xp-bonus {
    position: absolute;
    z-index: 3;
    top: 0;
    right: 0;
    background: gold;
    transform: translate(20%, -50%) rotate(-3deg);
  }

  &:hover {
    transform: translateY(-3px);

    .hand {
      transform: translate(0, 100%) rotate(-45deg);
    }

    .beancan-boom {
      opacity: 1;
      transform: rotate(8deg) scale(1);
    }

    .icon-ctn .rust-items .case-item {
      opacity: 1;
      transform: translateY(0) translateX(0) scale(1);
    }

    .game-info {
      transform: translate(16px, -20%) rotate(2deg) scale(1.1);
    }

    .game-stats {
      transform: translate(16px, -10%) rotate(2deg) scale(1.1);
    }
  }
}

@keyframes spin {
  from {
    transform: rotateX(30deg);
  }

  to {
    transform: rotateX(390deg);
  }
}
</style>
